<script>
        import TablaEspuma from "./EspumaTabla.svelte";
        var espuma = false;
        function mostrarDiv(id){
            espuma = !espuma;
    }
    let isMobile = false;
    function checkIsMobile() {
  isMobile = window.innerWidth <= 1000; // Puedes ajustar el valor según tus necesidades
}

// Llama a la función al cargar la página
checkIsMobile();

// Escucha el evento de cambio de tamaño de la ventana para actualizar el valor
window.addEventListener('resize', checkIsMobile);
</script>
<div class="row">
    <div class="col-12 col-lg-6 linea">
    </div>
    <div class="col-12 col-lg-6">
        <h3>Espuma de Polietileno con Aluminio</h3>
    </div>
</div>
<div class="row">
    <div class="col-12 col-lg-4" style="text-align: center;">
        <img src="img/Low/espuma.png" width="75%" alt="Espuma termica IcemaGeles">
    </div>
    {#if !isMobile}
        <div class="col-12 col-lg-8">
            <p class="parrafo-cuadro">Es fácilmente lavable, es termosoldable, impidiendo que entre agua por las uniones, mejora la higiene interna! 

                Resistentes a productos químicos, NO desprende partículas, ningun riesgo de que se humedece o se degrade.
                
                El material tiene baja propagación de llama y los gases producto de su combustión NO son tóxicos.
                
                Por último debe considerarse la facilidad de colocación, durabilidad y seguridad que otorga este tipo de aislamiento respecto  a los comúnmente usados.             </p>
        </div>
        <div class="col-12">
            <h3>Ventajas:</h3>
        </div>
        <div class="col-12">
            <ul>
                <li>Excelente Terminación</li>
                <li>Cuentan con garantía por toda la vida útil de la cubierta</li>
                <li>No produce puentes térmicos en la instalación</li>
            </ul>
        </div>
        <div class="col-12" style="text-align:center;">
            <button class="boton-info" on:click={() => mostrarDiv("espuma")}>+Info</button>
        </div>    
        {#if espuma}
        <TablaEspuma />
        {/if}
    {:else}
        <div class="col-12">
            <h3>Ventajas:</h3>
        </div>
        <div class="col-12">
            <ul>
                <li>Excelente Terminación</li>
                <li>Cuentan con garantía por toda la vida útil de la cubierta</li>
                <li>No produce puentes térmicos en la instalación</li>
            </ul>
        </div>
        <div class="col-12" style="text-align:center;">
            <button class="boton-info" on:click={() => mostrarDiv("espuma")}>+Info</button>
        </div>    
        {#if espuma}
        <div class="col-12 col-lg-8">
            <p class="parrafo-cuadro">Es fácilmente lavable, es termosoldable, impidiendo que entre agua por las uniones, mejora la higiene interna! 

                Resistentes a productos químicos, NO desprende partículas, ningun riesgo de que se humedece o se degrade.
                
                El material tiene baja propagación de llama y los gases producto de su combustión NO son tóxicos.
                
                Por último debe considerarse la facilidad de colocación, durabilidad y seguridad que otorga este tipo de aislamiento respecto  a los comúnmente usados.             </p>
        </div>
        <TablaEspuma />
        {/if}

    {/if}
    </div>